<template>
  <section class="how-to-section">
    <div class="container">
      <div class="row">
        <h2 v-animation class="how-to-title col col-10 offset-1" data-animation="fade-in-up">
          <strong>How to use</strong> the statistics calculators
        </h2>
        <VideoCarousel v-animation class="col col-12" data-animation="pop-out" />
      </div>
    </div>
  </section>
</template>

<script>
import VideoCarousel from '@itbpbg/lms-components/src/HomeV3/VideoCarousel.vue';

export default {
  components: {
    VideoCarousel,
  },
  data() {
    return {
    };
  },
  methods: {
  },
};
</script>

<style scoped lang="scss">
.how-to-section {
  padding: 60px 0;

  .how-to-title {
    text-align: center;
    font-size: 44px;
    font-weight: 400;

    > strong {
      text-transform: uppercase;
    }
  }
}

@include bp($bp-laptop-tablet) {
  .how-to-section {
    padding: 40px 0;

    .how-to-title {
      font-size: 40px;
    }
  }
}

@include bp($bp-mobile) {
  .how-to-section {
    padding: 40px 0;

    .how-to-title {
      font-size: 32px;
    }
  }
}
</style>
